import React from 'react';
import classNames from 'classnames';
import { FlexCol } from '@minecraft.atoms';
import { WindowWidthContext } from '@minecraft.utils';
import { CheckoutProps } from '../Checkout/types';
import { OrderSuccessWrapperProps } from '../OrderSuccess/types';
import { PAYWALL_STEPS } from '../enums/paywall';
import { OrderSuccessWraper } from '../OrderSuccess/OrderSuccessWrapper';
import { CheckoutWrapper } from '../Checkout/CheckoutWrapper';
import { PlanSelectionWrapper } from '../PlanSelection/PlanSelectionWrapper';
import { BillingCodes } from '../enums/plans';

type DefaultPaywallProps = OrderSuccessWrapperProps &
  CheckoutProps & {
    step?: PAYWALL_STEPS;
  };

export const DefaultPaywallExperience = ({
  isModal,
  selectedPlan,
  completedPurchase,
  completePurchaseLoading,
  paywallLocation,
  subscription,
  countryCode,
  currencyCode,
  addPaymentError,
  addPaymentLoading,
  applyCouponError,
  completePurchaseError,
  couponLoading,
  currentPurchase,
  enableAnnualRenewal,
  getTitle,
  isAnnual,
  onAddPaymentOption,
  onApplyCoupon,
  onBack,
  onCompletePurchase,
  onNext,
  onRemoveCoupon,
  onSelectPaymentOption,
  onThreeDActionError,
  plansError,
  plansLoading,
  selectedPaymentOption,
  setIsAnnual,
  setSelectedPlan,
  setShowAddPaymentMethod,
  showAddPaymentMethod,
  onUpdatePaymentOption,
  threeDActionContext,
  wallet,
  walletLoading,
  isWithinTrialPeriod,
  previewMediaPurchase,
  previewMediaPurchaseLoading,
  previewMediaPurchaseError,
  isAnnualToggleLocked,
  currentProfile,
  modalVariant,
  hideIsAnnualToggle,
  isReactivate,
  isTrialEligible,
  step,
  onPaymentCompleteRedirect,
  closeBillingPopup,
  plans,
  startingStep,
  discountType,
}: DefaultPaywallProps) => {
  const isMobile = WindowWidthContext.useIsMobile();

  return (
    <FlexCol w="full" className={classNames({ 'cn_mt-2': !isModal })} justifyContent="center" alignItems="center">
      {PAYWALL_STEPS.SUCCESS === step && (
        <OrderSuccessWraper
          isModal={isModal}
          selectedPlan={selectedPlan}
          completedPurchase={completedPurchase}
          lessMd={isMobile}
          completePurchaseLoading={completePurchaseLoading}
          paywallLocation={paywallLocation}
          onPaymentCompleteRedirect={onPaymentCompleteRedirect}
          subscription={subscription}
          countryCode={countryCode}
          currencyCode={currencyCode}
          closeBillingPopup={closeBillingPopup}
        />
      )}
      {PAYWALL_STEPS.CHECKOUT === step && (
        <CheckoutWrapper
          addPaymentError={addPaymentError}
          addPaymentLoading={addPaymentLoading}
          applyCouponError={applyCouponError}
          completePurchaseError={completePurchaseError}
          completedPurchase={completedPurchase}
          completePurchaseLoading={completePurchaseLoading}
          countryCode={countryCode}
          couponLoading={couponLoading}
          currencyCode={currencyCode}
          currentPlanCode={subscription?.plan?.billingCode as BillingCodes}
          currentPurchase={currentPurchase}
          enableAnnualRenewal={enableAnnualRenewal}
          getTitle={getTitle}
          isAnnual={isAnnual}
          isModal={isModal}
          lessMd={isMobile}
          onAddPaymentOption={onAddPaymentOption}
          onApplyCoupon={onApplyCoupon}
          onBack={onBack}
          onCompletePurchase={onCompletePurchase}
          onNext={onNext}
          onRemoveCoupon={onRemoveCoupon}
          onSelectPaymentOption={onSelectPaymentOption}
          onThreeDActionError={onThreeDActionError}
          paywallLocation={paywallLocation}
          plans={plans}
          plansError={plansError}
          plansLoading={plansLoading}
          selectedPaymentOption={selectedPaymentOption}
          selectedPlan={selectedPlan}
          selectedPlanTerm={isAnnual ? 'annual' : 'monthly'}
          setIsAnnual={setIsAnnual}
          setSelectedPlan={setSelectedPlan}
          setShowAddPaymentMethod={setShowAddPaymentMethod}
          showAddPaymentMethod={showAddPaymentMethod}
          onUpdatePaymentOption={onUpdatePaymentOption}
          startingStep={startingStep}
          threeDActionContext={threeDActionContext}
          wallet={wallet}
          walletLoading={walletLoading}
          isWithinTrialPeriod={isWithinTrialPeriod}
          previewMediaPurchase={previewMediaPurchase}
          previewMediaPurchaseLoading={previewMediaPurchaseLoading}
          previewMediaPurchaseError={previewMediaPurchaseError}
          closeBillingPopup={closeBillingPopup}
          onPaymentCompleteRedirect={onPaymentCompleteRedirect}
          isAnnualToggleLocked={isAnnualToggleLocked}
          currentProfile={currentProfile}
          modalVariant={modalVariant}
          discountType={discountType}
        />
      )}
      {![PAYWALL_STEPS.CHECKOUT, PAYWALL_STEPS.SUCCESS].includes(step) && (
        <PlanSelectionWrapper
          onNext={onNext}
          isAnnual={isAnnual}
          plans={plans}
          plansError={plansError}
          plansLoading={plansLoading}
          setIsAnnual={setIsAnnual}
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
          countryCode={countryCode}
          getTitle={getTitle}
          lessMd={isMobile}
          onBack={onBack}
          startingStep={startingStep}
          paywallLocation={paywallLocation}
          isModal={isModal}
          onCompletePurchase={onCompletePurchase}
          completePurchaseLoading={completePurchaseLoading}
          completePurchaseError={completePurchaseError}
          onPaymentCompleteRedirect={onPaymentCompleteRedirect}
          enableAnnualRenewal={enableAnnualRenewal}
          isTrialEligible={isTrialEligible}
          isReactivate={isReactivate}
          hideIsAnnualToggle={hideIsAnnualToggle}
          modalVariant={modalVariant}
        />
      )}
    </FlexCol>
  );
};
